import { Box, Grid, Typography } from "@mui/material";
import React from "react";

export default function TestPrepSubserviceCards({
  firstImage,
  title,
  subtitle,
  onClick,
  color,
}) {
  return (
    <>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        onClick={onClick}
      >
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexDirection: "row",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Box>
              <Box sx={{ width: "35px", height: "35px" }}>
                <img src={firstImage} alt="img" width="100%" height="100%" />
              </Box>
            </Box>

            <Box>
              <Typography
                textAlign="center"
                sx={{
                  fontFamily: "Inetr",
                  fontWeight: 700,
                  fontSize: "18px",
               
                  color: { color },
                }}
              >
                {title}
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Typography
            sx={{
              fontFamily: "Inter",
         
              fontSize: "12px",
              fontWeight: 500,
              color: "#5F6570",
            }}
          >
            {subtitle}
          </Typography>
        </Grid>

        <Grid item xs={12}> 
          <Box display="flex" alignItems="center" gap={1}>
          <Typography  sx={{
              fontFamily: "Inter",
         
              fontSize: "14px",
              fontWeight: 600,
              color: "#572575",
            }}>Learn More</Typography>
            <Box width={16}><img src="/newdashboard/Sub service/Group 1000016419.png"/></Box>
            </Box>
        </Grid>
      </Grid>
    </>
  );
}
